import { useMemo } from 'react';
import { Box, IconButton } from '@mui/material';
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';
// project import
import { useSelector, useDispatch } from 'react-redux';
import MissionService from 'services/mission/MissionService';
import { useSnackbar } from 'notistack';

const ChangeOrdinal = props => {
    const { row, field, slice } = props;

    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const mission = useSelector(state => state[slice]?.mission);
    const missionStepsUpdate = steps => {
        dispatch(
            MissionService.updateMission({
                ...mission,
                steps: steps,
            }),
        )
            .then(() => {
                enqueueSnackbar('Data saved', { variant: 'success' });
            })
            .catch(error => {
                enqueueSnackbar(error.message, { variant: 'error' });
            });
    };

    const handleClick = event => {
        event.stopPropagation();
        event.preventDefault();
        const data = mission?.steps;
        if (!row || !data || data?.length === 0) return;
        let coordinates = [];
        const indexFrom = data.findIndex(x => x.id === row.id);
        const move = (array, from, to) => {
            let newArray = array.slice();
            newArray.splice(to, 0, newArray.splice(from, 1)[0]); //
            return newArray;
        };
        let modifiedData = move(
            data,
            indexFrom,
            field === 'up' ? indexFrom - 1 : indexFrom + 1,
        );
        modifiedData = modifiedData.map((elem, index) => {
            coordinates.push(elem.coordinates);
            return { ...elem, ordinal: index + 1 };
        });

        missionStepsUpdate(modifiedData);
    };

    const isEnabledIcon = useMemo(() => {
        return (
            (field === 'up' && row?.ordinal !== 1) ||
            (field === 'down' && row?.ordinal !== mission?.steps?.length)
        );
    }, [row, mission, field]);

    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
            }}
        >
            {isEnabledIcon && (
                <IconButton
                    disableRipple
                    aria-label="change_ordinal"
                    onClick={handleClick}
                    color="secondary"
                >
                    {field === 'up' ? (
                        <CaretUpOutlined />
                    ) : (
                        <CaretDownOutlined />
                    )}
                </IconButton>
            )}
        </Box>
    );
};
export default ChangeOrdinal;
